"use client";

import { OffersOffer } from '@/services/dataTypes';
import React, { useState } from 'react';
import { filterOfferBanners, getBannerDimensions } from '@/constants/hooks';
import Banner from './Banner';

interface Props {
    bannerResponse: OffersOffer[];
    domain: string;
    mer_slug: string;
    slug_type: string;
}

const VerticalPromotionOfferBanner = ({ bannerResponse, domain, mer_slug, slug_type }: Props) => {
    const filtered = filterOfferBanners(bannerResponse, 50, 2000, 65, 2000);
    const [visibleCount, setVisibleCount] = useState(6);
    const [loading, setLoading] = useState(false);

    const handleShowMore = () => {
        setLoading(true);
        setTimeout(() => { setVisibleCount(p => p + 6); setLoading(false); }, 300);
    };

    if (!filtered?.length) return null;

    const displayedBanners = filtered.slice(0, visibleCount);
    const hasMore = visibleCount < filtered.length;

    return (
        <div
            className="rounded-2xl overflow-hidden"
            style={{ border: '1px solid #E8F5EE', background: '#FFFFFF' }}
        >
            {/* Header */}
            <div
                className="flex items-center gap-2.5 px-4 py-3"
                style={{ background: '#F7FBF9', borderBottom: '1px solid #E8F5EE' }}
            >
                <div className="w-1 h-4 rounded-full bg-[#5D27A1]" />
                <span className="text-[11px] font-bold uppercase tracking-wide" style={{ color: '#1E293B' }}>
                    Banner Offers
                </span>
                {/* {filtered.length > 0 && (
                    <span
                        className="ml-auto text-[10px] font-semibold px-2 py-0.5 rounded-full"
                        style={{ background: '#E8F5EE', color: '#5D27A1' }}
                    >
                        {filtered.length}
                    </span>
                )} */}
            </div>

            {/* Banners */}
            <div className="p-3 flex flex-col gap-2.5">
                {displayedBanners.map((offer_data, i) => {
                    const dimension = getBannerDimensions(offer_data);
                    return (
                        <div
                            key={i}
                            className="rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md"
                            style={{ border: '1px solid #E8F5EE' }}
                        >
                            <Banner
                                data={offer_data}
                                height={dimension?.height}
                                mer_slug={mer_slug}
                                slug_type={slug_type}
                                domain={domain}
                                width={dimension?.width}
                            />
                        </div>
                    );
                })}
            </div>

            {/* Show more */}
            {hasMore && (
                <div className="px-3 pb-3">
                    <button
                        onClick={handleShowMore}
                        disabled={loading}
                        className="w-full flex items-center justify-center gap-2 py-2.5 rounded-xl text-[11px] font-bold uppercase tracking-widest transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md active:scale-[0.98] disabled:opacity-60"
                        style={{
                            background: 'linear-gradient(135deg, #5D27A1 0%, #471d7c 100%)',
                            color: '#FFFFFF',
                            border: '1px solid rgba(74,154,110,0.2)',
                        }}
                    >
                        {loading ? (
                            <span
                                className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"
                            />
                        ) : (
                            <>
                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                                </svg>
                                Show More
                            </>
                        )}
                    </button>
                </div>
            )}
        </div>
    );
};

export default VerticalPromotionOfferBanner;
